import React from "react";
import { Grid } from "@mui/material";
import Header from "./header";


export default function Layout({ children }) {
  return (
    <Grid
      sx={{
        height: "100dvh",     // ✅ real fullscreen height
        overflowX: "hidden",  // ❌ page scroll band
      }}>
      <Header />
      <Grid
        sx={{
          height: "calc(100dvh - 64px)", // header height minus
          overflow: "hidden",
        }}
      >
        {children}
      </Grid>
    </Grid>
  )
}